import Vue from 'vue';
import Component from 'vue-class-component';
import { G2S } from 'core/g2s';
import * as utils from 'core/utils';
import { Prop } from 'vue-property-decorator';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');
@WithRender
@Component
export class LanguageDropdownComponent extends Vue {

    @Prop()
    markets: []; 

    @Prop()
    currentMarket:any;
    
    currencyValue: string = '';
    languageValue: string = '';
    marketCode: string = '';
    
    get currency() {
        return this.currencyValue;
    }

    get language() {
        return this.languageValue;
    }

    mounted() {
        this.marketCode = G2S.config.marketCode; // ru
    }

    changeCurrentMarket(market){
        this.$emit('on-change', market);
    }
    
    getCurrencySymbol(code) {
        return utils.String.currencySymbol(code);
    }

    setCurrency(newValue: string) {
        this.currencyValue = newValue;
    }

    setLanguage(newValue: string) {
        this.languageValue = newValue;
    }
    
    onOpenDropdow(){
        (<any>this).$ga.sendEvent('market', 'open.dropdown', 'market.open.dropdown');
    }
}